import React from 'react';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import {
  Box,
  Text
} from 'grommet'
import RenderRichText from '../../utils/RenderRichText';
import ContentWrap from '../ContentWrap';

const ComponentText = ({field, nopadding = false, fullwidth = false}) => {

  function checkBig() {
    if (field.fields.hasOwnProperty('big') && field.fields.big === true){
      return true
    } else {
      return false
    }
  }

  function checkBigSize() {
    if (field.fields.hasOwnProperty('big') && field.fields.big === true){
      return "xlarge"
    } else {
      return "medium"
    }
  }

  function checkCentered() {
    if (field.fields.hasOwnProperty('centered') && field.fields.centered){
      return "center"
    } else {
      return "start"
    }
  }

  function checkCenteredPadding() {
    if (field.fields.hasOwnProperty('centered') && field.fields.centered){
      return "large"
    } else {
      return "none"
    }
  }

  return (
    <ContentWrap nopadding={checkBig()} fullwidth={fullwidth}>
      <Box
        className={checkCentered()}
      >
        <Text 
          className={"richText " + (checkBig() ? 'bigText' : 'normalText')} 
          size={checkBigSize()} 
          textAlign={checkCentered()} 
        >
        {RenderRichText(field.fields.text)}
        </Text>
      </Box>
    </ContentWrap>
  )
}

export default ComponentText;
